export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "consultantName",
    numeric: false,
    disablePadding: true,
    label: "Consultant Name",
  },
  {
    id: "speciality",
    numeric: true,
    disablePadding: false,
    label: "Speciality",
  },
  {
    id: "contactNumber",
    numeric: true,
    disablePadding: false,
    label: "Contact Number",
  },
  {
    id: "revenue",
    numeric: true,
    disablePadding: false,
    label: "Consult Fee(₹)",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
